import { component } from 'picoapp';
import { gsap } from 'gsap';
import { ScrollToPlugin } from 'gsap/ScrollToPlugin';

gsap.registerPlugin(ScrollToPlugin);

export default component((node, ctx) => {
  const switcher = node.querySelector('.js-switcher');
  const header = switcher.querySelector('.js-switcher-header');
  const content = switcher.querySelector('.js-switcher-content');
  const readMore = switcher.querySelector('.read-more');
  const readLess = switcher.querySelector('.read-less');
  const about = switcher.querySelector('.js-about');
  const aboutContent = about.querySelector('.js-about-content');
  const spec = switcher.querySelector('.js-spec');
  const brew = switcher.querySelector('.js-brew') || false;

  const mql = window.matchMedia('(max-width: 767px)');
  const isMobile = mql.matches;
  const PADDING = 24;

  let aboutMaxHeight, aboutFullHeight;

  function init() {
    aboutMaxHeight = isMobile ? 330 : 480;
    aboutFullHeight = about.clientHeight;

    // Set inactive tabs to min About height
    [brew,spec].forEach((el) => {
      if(!el) return;
      gsap.set(el, { height: `${aboutMaxHeight}px` });
    });
   
    // If there is more 'About' content to reveal, show 'Read More' button and add event listener
    if (aboutFullHeight > aboutMaxHeight) {
      readMore.addEventListener('click', showMoreContent);
      showLessContent();
    }

    header.addEventListener('click', (e) => {
      if (e.target.dataset?.tab) {
        switchTab(e.target.dataset.tab);
      }
    });
  }

  function showButton(button) {
    gsap.set(button, { display: 'flex' });
  }

  function hideButton(button) {
    gsap.set(button, { display: 'none' });
  }

  function showMoreContent() {
    showButton(readLess);
    hideButton(readMore);
    gsap.set(about, { height: 'auto' });
    gsap.to(aboutContent, { height: 'auto' });
    readLess.addEventListener('click', () => {
      showLessContent();
      scrollToTop();
    }, { once: true });
  }

  function showLessContent() {
    showButton(readMore);
    hideButton(readLess);
    gsap.to(aboutContent, { height: `${aboutMaxHeight - PADDING}px` });
  }

  function scrollToTop() {
    gsap.to(window, {
      delay: 0.5,
      duration: 0.5, scrollTo: {
        y: switcher,
        offsetY: ctx.getState().headerHeight + PADDING,
      }
    });
  }

  function switchTab(tab) {
    if (tab == 'about') showLessContent();
    [about, brew, spec].forEach((el) => {
      if (!el) return;
      gsap.set(el, { height: `${aboutMaxHeight}px` });
    });

    // Change active state on buttons
    header.querySelector('.is-active')?.classList.remove('is-active');
    header.querySelector(`[data-tab="${tab}"]`)?.classList.add('is-active');

    // Shrink and fade out currently active tab
    const currentTab = content.querySelector('.is-active');
    gsap.to(currentTab, { height: `${aboutMaxHeight}px` });
    currentTab.classList.remove('is-active');

    // Grow and fade in newly active tab
    const newTab = content.querySelector(`[data-tab="${tab}"]`);
    newTab.classList.add('is-active');
    gsap.to(newTab, { height: 'auto', overwrite: true });
  }

  init();
});
